var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReAttemptLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 8.33464H16.6667C17.1269 8.33464 17.5 8.70772 17.5 9.16797V17.5013C17.5 17.9616 17.1269 18.3346 16.6667 18.3346H3.33333C2.8731 18.3346 2.5 17.9616 2.5 17.5013V9.16797C2.5 8.70772 2.8731 8.33464 3.33333 8.33464H4.16667V7.5013C4.16667 4.27964 6.77834 1.66797 10 1.66797C13.2217 1.66797 15.8333 4.27964 15.8333 7.5013V8.33464ZM14.1667 8.33464V7.5013C14.1667 5.20012 12.3012 3.33464 10 3.33464C7.69882 3.33464 5.83333 5.20012 5.83333 7.5013V8.33464H14.1667ZM9.16667 11.668V15.0013H10.8333V11.668H9.16667Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReAttemptLock);
export default __webpack_public_path__ + "static/media/re_attempt_lock.79be4bdeb1079003f5938ce86db3161a.svg";
export { ForwardRef as ReactComponent };